import axios from 'axios'
import { queryStackChart, queryListOfDriver } from '@/setting/queryText.js'
import dayjs from 'dayjs'
import { API, graphqlOperation } from 'aws-amplify'

async function getLateNotLate (_dateTime) {
  const query = `query MyQuery {
        getDateTimebyDateTime(dateTime: "${_dateTime}") {
          items {
            latesDaily {
              items {
                notLate
                late
              }
            }
          }
        }
      }`
  const res = await API.graphql(graphqlOperation(query))
  // console.log(
  //   'query getLateNotLate',
  //   res.data.getDateTimebyDateTime.items[0].latesDaily.items[0]
  // )
  const _temp = res.data.getDateTimebyDateTime.items[0].latesDaily.items[0]
  if (_temp === undefined) {
    return {
      notLate: 0,
      late: 0
    }
  } else {
    return _temp
  }
}

async function getStackChartData (_date) {
  // console.log('queryStackChart', queryStackChart)
  const res = await API.graphql(
    graphqlOperation(queryStackChart.replace('$date', `"${_date}"`))
  )
  const _temp = res.data.getDateTimebyDate.items

  const statData = {}
  statData.date = _date
  statData.successOrder = []
  for (const ele of _temp) {
    if (ele.statusesHour.items[0] === undefined) {
      statData.successOrder.push(null)
    } else {
      statData.successOrder.push(ele.statusesHour.items[0].successOrder)
    }
    // console.log(ele.statusesHour.items)
  }
  // console.log('statData', statData)
  return statData
}

async function getExpressSLAData (_dateTime) {
  const _data = JSON.stringify({
    query: `query MyQuery {
      getExpressSLA(date: "${_dateTime}") {
        date
        data
      }
    }`
  })

  const _config = {
    method: 'post',
    url:
      'https://p2ha77gfjzhl7nbjoiwolwmleu.appsync-api.ap-southeast-1.amazonaws.com/graphql',
    headers: {
      'x-api-key': 'da2-dnzqionk6jc7fjd5ieqfehqz54',
      'Content-Type': 'application/json'
    },
    data: _data
  }
  const _temp = await axios(_config).then(function (response) {
    console.log('response', response)
    if (response.data?.data?.getExpressSLA?.data) {
      return JSON.parse(JSON.parse(response.data.data.getExpressSLA.data))
    }
  })
  console.log('_temp', _temp)
  return _temp
}

const initialState = {
  lateCount: {
    notLate: null,
    late: null
  },
  stackChart: null,
  listOfDriver: {
    latesDaily: null,
    latesDriverDaily: null
  },
  expressSLA: null
}
const drivePerformance = {
  namespaced: true,
  state: initialState,
  getters: {
    lateCount: state => {
      return state.lateCount
    },
    stackChart: state => {
      return state.stackChart
    },
    listOfDriver: state => {
      return state.listOfDriver
    },
    expressSLA: state => {
      return state.expressSLA
    }
  },
  mutations: {
    setLateCount (state, value) {
      state.lateCount = value
    },
    setStackChart (state, value) {
      state.stackChart = value
    },
    setlistOfDriver: (state, value) => {
      state.listOfDriver = value
    },
    setExpressSLA: (state, value) => {
      state.expressSLA = value
    }
  },
  actions: {
    async getLateCount (context, dateTime) {
      // console.log('getLateNotLate(dateTime)', dateTime)
      const temp = await getLateNotLate(dateTime)

      // console.log(temp)
      context.commit('setLateCount', temp)
    },
    async getStackChart (context, { dateBetween, initDate }) {
      const _stackChart = []
      for (let i = 0; i < dateBetween; i++) {
        const _date = dayjs(initDate)
          .subtract(i, 'day')
          .format('YYYY-MM-DD')
        console.log(_date)
        _stackChart.push(await getStackChartData(_date))
      }
      // console.log('setStackChart', _stackChart)
      context.commit('setStackChart', _stackChart)
    },
    async getListOfDriver (context, { dataRange, _dateTime }) {
      let _temp
      let res
      switch (dataRange) {
        case 'AllTime':
          if (dayjs().get('hour') < 23) {
            _dateTime = dayjs()
              .subtract(1, 'day')
              .format('YYYY-MM-DDT16:00:00[Z]')
          } else {
            _dateTime = dayjs().format('YYYY-MM-DDT16:00:00[Z]')
          }
          console.log('AllTime', _dateTime)
          res = await API.graphql(
            graphqlOperation(
              queryListOfDriver
                .replace('$date', `"${_dateTime}"`)
                .replace('latesDriverDaily', 'latesDriverAllTime')
            )
          )
          // console.log('query LateDriver', res.data)
          _temp = res.data.getDateTimebyDateTime.items[0]
          context.commit('setlistOfDriver', _temp)
          break
        case 'Daily':
          console.log('Daily', _dateTime)
          res = await API.graphql(
            graphqlOperation(
              queryListOfDriver.replace('$date', `"${_dateTime}"`)
            )
          )
          // console.log('query LateDriver', res.data)
          _temp = res.data.getDateTimebyDateTime.items[0]
          // console.log('getListOfDriver', _temp)
          context.commit('setlistOfDriver', _temp)
          break
      }
    },
    async getExpressSLA (context, payload) {
      console.log('get express sla')
      const expressSLA = await getExpressSLAData(payload)
      context.commit('setExpressSLA', expressSLA)
    }
  }
}

export default drivePerformance
